import React from 'react';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import {Collapse,Fade } from 'reactstrap';
import DashboardSectionHeading from '../DashboardSectionHeading';
import DiscoverNewTile from './DiscoverNewTile';
import { Typography, Icon, LinkText } from "../../ecosystem";
import { logUI } from "../../../api/andyliticsApi";
import * as types from "../../../constants/actionTypes";
import * as Tools from "../../../helpers/Tools";

import './discover.scss';

/*
import DashboardSectionHeading from "../DashboardSectionHeading";

*/
const SEE_MORE = "See More";
const SEE_LESS = "See Less";
const Discover = (props) => {
    const [fadeIn, setFadeIn] = useState(true);
    const [seeLabel, setSeeLabel] = useState(SEE_MORE);
    useEffect(() => {/*console.info(`Discover useEffect props.bffLoaded`, props);*/}, [props.bffLoaded]);

    useEffect(() => {/*console.info(`Discover SEE change`, seeLabel);*/}, [seeLabel]);

    useEffect(() => {/*console.info(`***Discover useEffect props.tiles`, props.tiles);*/}, [props.tiles]);
    const toggleBottomTileRow = () => {
        try {
            if (seeLabel === SEE_MORE) {
                const bottomTiles = document.querySelector(".discover-tiles-container-bottom");
                const styles = window.getComputedStyle(bottomTiles);
                const bottomHeight = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
                const newHeight = Math.ceil(bottomTiles.offsetHeight + bottomHeight);

                setSeeLabel(SEE_LESS);
            }
            else {
                setSeeLabel(SEE_MORE);
            }
        } catch (e) {
            logUI('MBHWeb.Discover.toggleBottomTileRow', new Date(), Tools.getURLPath(), { "bottomTiles": document.querySelector(".discover-tiles-container-bottom"), tiles: props.tiles });
        }
    }
    const dismissTile = (tile) => {
        setFadeIn(false);
        props.dismissTile(props.authToken, tile);
        setFadeIn(true);
    }

    return <div className="discover-container">
            <DashboardSectionHeading heading="Discover Something New"
                onClick={(e) => {
                    if (e && e.ctrlKey && serverData.data.environment !== "PROD") {
                        props.unDismissAll(props.authToken);
                    }
                    e.preventDefault();
                    }
                }
                isMobile={props.isMobile}
                mTop={props.isMobile && "xs"}
                sideLink={{
                    url: "", label:(!props.isMobile && props.tiles.length > 2) ? <div className="accordionControl">{seeLabel}<Icon name={seeLabel === SEE_MORE?"chevron-down":"chevron-up"}/></div>:<></>, onClick: (e) => {
                        if (e.ctrlKey && serverData.data.environment !== "PROD") {
                            props.unDismissAll(props.authToken);
                        } else {
                            toggleBottomTileRow();
                        }
                    }
                }} 
            />
            {(props.tiles.length > 0) ?
                <div className="discover-tiles row">
                    <div className="discover-tiles-container col-12 ">
                        <div className="discover-tiles-container-top  row">
                            {props.tiles.map((tile, index) =>
                                <div
                                    className={`discover-tile col-lg-6 col-xs-12 ${(index < 2)? '' : 'hidden'}`}
                                    key={index}
                                >
                                    <DiscoverNewTile
                                        key={tile.tileId}
                                        className=""
                                        borderStyle="flat"
                                        history={props?.history}
                                        location={props?.location}
                                        match={props?.match}
                                        onArrowClick={(clickedTile) => { }}
                                        onXClick={dismissTile}
                                        {...tile}
                                    />
                                </div>
                            )}
                        </div>
                        <Collapse isOpen={(seeLabel === SEE_LESS)}>
                        <div className="discover-tiles-container-bottom  row" >
                            {props.tiles.map((tile, index) => {
                                if (index > 1) {
                                    return <div
                                        className={`discover-tile col-lg-6 col-xs-12 ${(index > 1) ? '' : 'hidden'}`}
                                        key={index}
                                    >
                                        <DiscoverNewTile
                                            key={tile.tileId}
                                            className=""
                                            borderStyle="flat"
                                            history={props?.history}
                                            location={props?.location}
                                            match={props?.match}
                                            onArrowClick={(clickedTile) => { }}
                                            onXClick={dismissTile}
                                            {...tile}
                                        />
                                    </div>;
                                }
                            })}


                                <div className={(props.isMobile) ? `discover-tiles__link` : `hidden`}>
                                        <LinkText
                                            onClick={() => {
                                                    setSeeLabel(SEE_MORE);
                                            }}
                                            typographyType="body-02"
                                        >
                                            {seeLabel}
                                        </LinkText>
                                    </div>
                                </div>
                                    
                        </Collapse>

                    </div>
                

                <div className={(props.isMobile && props.tiles.length > 2) && (seeLabel === SEE_MORE)
                    ? `discover-tiles__link` : `hidden`}>
                        <LinkText
                            onClick={() => {
                                    setSeeLabel(SEE_LESS);
                            }}
                            typographyType="body-02"
                        >
                        {seeLabel}
                        </LinkText>
                    </div>
                </div>
                :
                <div className="col-12 d-flex justify-content-center discover-container__no-tiles">
                    <Typography color="color-secondary-a2" type="body-02" textAlign="center">
                        Looks like you’re all caught up! No new recommendations. 
                    </Typography>
                </div>
            }

        </div>

}
const mapStateToProps = (state) => {
    const isWaiting = state?.dashboard?.bffDashboardData?.isWaiting ?? true;
    return {
        authToken: state.domain.t,                                                                                                                    
        bffLoaded: !isWaiting,
        currentUser: state?.dashboard?.bffDashboardData?.data?.currentUser ?? undefined,//from BFF
        memberships: state?.memberships ?? undefined,//from memberships
        isProxyUser: state.domain.ip,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        dismissTile: (token, tile) => {
            dispatch({ type: types.DISCOVER_TILE_DISMISS, token: token, tile: tile });
        },
        unDismissAll: (token) => {
            dispatch({ type: types.DISCOVER_TILE_UNDISMISS , token: token});
        }
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Discover));


